import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getMAGAC020Statistics, postMAGAC050Excel } from '../../../services/Api';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_MENUS } from '../../../shared/constants/app';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../shared/components/Loader';

const formatNumber = (value) => Number(value || 0).toLocaleString('ko-KR');
const formatDate = (value) => (value ? value.slice(0, 10) : '');
const formatPercentage = (value) => `${Number(value || 0).toFixed(1)}%`;

const MAGAC050 = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [statistics, setStatistics] = useState(null);
    const [selectedQuestionSeq, setSelectedQuestionSeq] = useState('');
    const [loading, setLoading] = useState(false);

    const selectedQuestion = useMemo(
        () =>
            statistics?.questionStatistics?.find(
                (question) => question.questionSeq === Number(selectedQuestionSeq)
            ),
        [statistics, selectedQuestionSeq]
    );

    useEffect(() => {
        const fetchStatistics = async () => {
            try {
                const { data } = await getMAGAC020Statistics(id);
                setStatistics(data);
                setSelectedQuestionSeq(data?.questionStatistics?.[0]?.questionSeq || '');
            } catch (error) {
                console.log(error);
            }
        };

        if (id) fetchStatistics();
    }, [id]);

    const handleDownloadAllParticipants = () => {
        window.alert('전체 결과 다운로드 API가 아직 연결되지 않았습니다.');
    };

    const handleDownloadQuestionResult = () => {
        window.alert('문항 결과 다운로드 API가 아직 연결되지 않았습니다.');
    };

    const handleDownload = (typeDownload) => {
        postMAGAC050Excel(id, typeDownload)
            .then((res) => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `이벤트 결과.${typeDownload}`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };

    return (
        <div className="container">
            <div className="wrap">
                <SideMenu menu={MENU_MENUS} />
                <div className="content-right magac050-result">
                    <h1 className="title">이벤트 결과</h1>
                    <div className="magac050-summary">
                        <div className="magac050-summary-item magac050-summary-title">
                            <span className="magac050-label">이벤트 제목</span>
                            <div>{statistics?.eventTitle || ''}</div>
                        </div>
                        <div className="magac050-summary-item">
                            <span className="magac050-label">이벤트 기간</span>
                            <div>
                                {formatDate(statistics?.startDate)} ~ {formatDate(statistics?.endDate)}
                            </div>
                        </div>
                    </div>

                    <div className="magac050-counts">
                        <div className="magac050-count-item">
                            <span className="magac050-label">조회수</span>
                            <div>{formatNumber(statistics?.visitedCnt)}회</div>
                        </div>
                        <div className="magac050-count-item">
                            <span className="magac050-label">전체 참여자 수</span>
                            <div>{formatNumber(statistics?.totalParticipants)}명</div>
                        </div>
                        <button className="magac050-outline-button" onClick={() => handleDownload('xlsx')} disabled={loading}>
                            {loading ? <Loader /> : '전체 결과 다운로드'}
                        </button>
                    </div>

                    <div className="magac050-question-select">
                        <label htmlFor="questionNo">문항별 결과 보기</label>
                        <select
                            id="questionNo"
                            value={selectedQuestionSeq}
                            onChange={(event) => setSelectedQuestionSeq(event.target.value)}
                        >
                            {(statistics?.questionStatistics || []).map((question) => (
                                <option key={question.questionSeq} value={question.questionSeq}>
                                    {question.questionTitle}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="magac050-detail">
                        <div className="magac050-detail-header">
                            <h2>문항 결과 상세</h2>
                            {/* <button type="button" className="magac050-outline-button" onClick={handleDownloadQuestionResult}>
                                문항 결과 다운로드
                            </button> */}
                        </div>

                        <table className="magac050-table">
                            <thead>
                                <tr>
                                    <th>NO.</th>
                                    <th>선택항목</th>
                                    <th>선택횟수</th>
                                    <th>비율</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedQuestion?.options?.map((option) => (
                                    <tr key={option.optionNo}>
                                        <td>{option.optionNo}</td>
                                        <td>{option.optionText}</td>
                                        <td>{formatNumber(option.voteCount)}명</td>
                                        <td>{formatPercentage(option.percentage)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div><br />
                    <button
                        type="button"
                        className="magac050-outline-button"
                        onClick={() => navigate('/magac010')}
                    >
                        목록
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MAGAC050;
